import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject
} from "@angular/core";
import { AvailabilityInfo } from "@app/models/dto/availability-info";
import moment from "moment";
import { Duration } from "moment";
import { NgxUiLoaderService, NgxUiLoaderModule } from "ngx-ui-loader";
import { SolverRules } from "@app/models/enums/solver-rules.enum";
import { MatButton } from "@angular/material/button";
import { NgClass } from "@angular/common";

class RuleEffect {
  rule: SolverRules;
}

@Component({
  selector: "app-availability-info-display",
  templateUrl: "./availability-info-display.component.html",
  styleUrls: ["./availability-info-display.component.scss"],
  imports: [NgxUiLoaderModule, MatButton, NgClass]
})
export class AvailabilityInfoDisplayComponent implements OnInit, OnChanges {
  protected ngxLoading = inject(NgxUiLoaderService);

  @Input() info: AvailabilityInfo;
  @Input() calculating: boolean;
  @Input() loaderId: string;

  travelTime = 0;
  idleTime = 0;
  endOfShiftTravelTime = 0;
  outOfReservation = false;
  ruleEffects: RuleEffect[];

  rules = [
    {
      name: "test",
      type: "soft",
      display: ""
    }
  ];
  // tileClass: string[] = ['panel-base', 'availability-info-panel-non-feasible'];
  overflow: boolean = false;
  infoClass: string[];
  outOfAppointment: boolean = false;
  showAdditionalDetail: boolean;

  ngOnInit() {
    if (this.info) {
      this.processScore();
    }
  }

  convertSoftScoreToTime(softscore: number): Duration {
    return moment.duration(softscore / (40000 / 60), "minutes");
  }

  getTooltip(info: AvailabilityInfo) {
    let tooltipText: string[] = ["Solver Scoring Stats"];
    info.effects.forEach((effect) => {
      tooltipText.push(`${effect.ruleName}`);
      tooltipText.push(`${effect.score.softScores},`);
      tooltipText.push(``);
    });
    return tooltipText.join("\n");
  }

  processScore() {
    this.infoClass = ["availability-info-panel"];
    this.infoClass.push("rank-" + (this.info.rank < 7 ? this.info.rank : 7));
    if (!this.info.feasible) {
      this.infoClass.push("availability-info-panel-non-feasible");
    } else {
      if (this.info.preferred) {
        if (this.info.best) {
          this.infoClass.push("availability-info-panel-best");
        } else {
          this.infoClass.push("availability-info-panel-feasible");
        }
      } else {
        this.infoClass.push("navailability-info-panel-feasible-false");
      }
    }
    this.travelTime = 0;
    this.idleTime = 0;
    this.overflow = false;
    this.outOfReservation = false;
    this.outOfAppointment = false;

    if (this.info && this.info.effects) {
      this.info.effects.forEach((value) => {
        console.log("assessing rule: " + value.ruleName);
        let rule = SolverRules[value.ruleName as keyof typeof SolverRules];
        console.log("matched rule: " + rule);
        switch (value.ruleName) {
          case "The total travel time between tickets should be minimised":
            this.travelTime = 0 - value.score.softScores[4] / 60;
            break;
          case "The total waiting time between tickets should be minimised":
            this.idleTime = 0 - (value.score.softScores[4] - 60) / 60;
            break;
          case "Minimise end of shift travel":
            this.endOfShiftTravelTime = 0 - value.score.softScores[4] / 60;
            break;

          case "Tickets must leave space in resource availability":
            this.overflow = true;
            // case 'Routes should be circularised':
            //   this.travelTime += value.softScores / 60;
            //   break;
            break;
          case "Normal Priority Reservation Exceeded":
          case "High Priority Reservation Exceeded":
          case "Emergency Priority Reservation Exceeded":
            this.outOfReservation = true;
            break;
          case "Tickets must not overrun appointment":
            this.outOfAppointment = true;
            break;
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("slot on changes " + this.loaderId);

    // If calculating flag is true, start the loader
    if (this.calculating) {
      // this.ngxLoading.startLoader(this.loaderId);
      // if (!this.ngxLoading.hasRunningTask(false, this.loaderId)) {
      this.ngxLoading.startLoader(this.loaderId);
      // }
    } else {
      // Only try to stop if we have an active loader
      // if (this.ngxLoading.hasRunningTask(false, this.loaderId)) {
      try {
        this.ngxLoading.stopLoader(this.loaderId);
      } catch (e) {
        console.error("Error stopping loader", e);
      }
      // }

      // Process the score if info exists
      if (this.info) {
        this.processScore();
      }
    }
  }

  roundMins(time: number) {
    return Math.round(time);
  }

  showAdditional() {
    this.showAdditionalDetail = true;
  }

  hideAdditional() {
    this.showAdditionalDetail = false;
  }
}
